"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changelog = exports.version = void 0;
exports.getVersion = getVersion;
exports.getChanges = getChanges;
exports.getVersionInfo = getVersionInfo;
exports.compareVersions = compareVersions;
const marked = require("marked");
function getVersion() {
    const rawChangelog = process.env.PTC_CHANGELOG;
    const matchVersion = rawChangelog && rawChangelog.match(/## (\d+\.\d+\.\d+)/);
    return (matchVersion && matchVersion[1]) || "";
}
exports.version = getVersion();
function getChanges(since) {
    const rawChangelog = process.env.PTC_CHANGELOG;
    if (!rawChangelog) {
        return "";
    }
    const changes = rawChangelog.substring(rawChangelog.indexOf(`## ${exports.version}`), since ? rawChangelog.indexOf(`## ${since}`) : rawChangelog.length);
    return marked.parse(changes, { async: false });
}
function getVersionInfo(since) {
    return {
        version: getVersion(),
        changes: getChanges(since),
    };
}
exports.changelog = getChanges();
function compareVersions(v1, v2) {
    const [major1, minor1, patch1] = v1.split(".");
    const [major2, minor2, patch2] = v2.split(".");
    return Number(major1) - Number(major2) || Number(minor1) - Number(minor2) || Number(patch1) - Number(patch2);
}
//# sourceMappingURL=version.js.map